import { Typography } from "@lyfegen-platform/react-common";
import { Box, Divider, Paper, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import LyfeTooltip from "../../../components/LyfeTooltip";
import renderCurrency from "../../../utils/currency";
import useStyles from "../use-styles";

interface SingleCardProps {
	property: string;
	value?: string | number;
	currency?: { Code: string; Name: string };
	children?: React.ReactChild | React.ReactChildren;
	isNotCurrency?: boolean;
	padding?: string;
	decimalPrecision?: "1" | "2";
	isTooltipShown?: boolean;
}
const SingleCard = (props: SingleCardProps) => {
	const { t } = useTranslation();
	const { headerSingleCard, fw500 } = useStyles();
	const {
		typography: { pxToRem },
	} = useTheme();

	const decimals = props.decimalPrecision === "2" ? [2, 2] : [2];

	return (
		<Paper className={headerSingleCard} style={{ height: !props.children ? "105px" : undefined, padding: props.padding }}>
			<Box display="flex" justifyContent="space-between" alignItems="center">
				<Typography className={fw500} color={"textPrimary"} variant={undefined} type={"h7"}>
					{t(props.property).toUpperCase()}
				</Typography>
				<Divider style={{ flexGrow: 1, margin: pxToRem(15) }} />
			</Box>
			{props.value !== undefined &&
				(props.isTooltipShown && props.currency?.Name ? (
					<LyfeTooltip title={props.currency?.Name}>
						<div>
							<Typography noWrap style={{ fontSize: pxToRem(18) }} variant={undefined}>
								{isNaN(+props.value) || props.isNotCurrency
									? props.value
									: renderCurrency(props.value, props.currency?.Code, ...decimals)}
							</Typography>
						</div>
					</LyfeTooltip>
				) : (
					<Typography noWrap style={{ fontSize: pxToRem(18) }} variant={undefined}>
						{isNaN(+props.value) || props.isNotCurrency
							? props.value
							: renderCurrency(props.value, props.currency?.Code, ...decimals)}
					</Typography>
				))}
			{props.children && <>{props.children}</>}
		</Paper>
	);
};

export default SingleCard;
